<template>
  <div>
    <Card>
      <ui-table
        :headers="headers"
        :items="filteredRows"
        class="main-table"
      >
        <template #items="{ item }">
          <div class="table-cell">
            {{ item.id }}
          </div>
          <div class="table-cell">
            {{ item.name }}
          </div>
        </template>
      </ui-table>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

const filteredRows = [
  { id: '1', name: '1' },
  { id: '2', name: '2' },
  { id: '3', name: '3' },
  { id: '4', name: '4' },
  { id: '5', name: '5' },
  { id: '6', name: '6' },
  { id: '7', name: '7' },
  { id: '8', name: '8' },
  { id: '9', name: '9' },
  { id: '10', name: 'text-10' },
  { id: '11', name: 'text-11' },
  { id: '12', name: 'text-12' },
  { id: '13', name: 'text-13' },
];

const headers = [
  {
    name: 'Name',
    value: 'name',
    sortable: true,
  },
  {
    name: 'Data',
    sortable: true,
  },
];
</script>

<style lang="scss" scoped>
.table-cell {
  width: 50%;
}
</style>
